<ng-container *ngIf="selectCustomObjectsEnabled$ | async; else disabledFeature">

@let vm = vm$();

<div class="w-100 h-100 flex-col custom-objects-container">
  @switch (vm.viewState) {
    @case ('LOADING') {
      <div class="h-100 w-100 flex-col center-center">
        <ui-preloader></ui-preloader>
      </div>
    }
    @case ('INITIAL_EMPTY') {
      <div class="h-100 w-100 flex-col center-center">
        <ui-no-data
          [imgSrc]="noData.imgSrc"
          [title]="noData.title | translate"
          [description]="noData.description | translate"
          [createButtonText]="noData.createButtonText | translate"
          (onCreate)="onCreateCustomObject()">
        </ui-no-data>
      </div>
    }
    @case ('NO_RESULTS') {
      <div class="h-100 w-100 flex-col center-center">
        <ui-no-data [imgSrc]="noResults.imgSrc" [title]="noResults.title | translate"></ui-no-data>
      </div>
    }
    @case ('HAS_DATA') {
      <div class="custom-objects-grid">
        @for (listItem of vm.filteredCustomObjects; track listItem.key) {
          <ui-custom-object-state-card
            [customObject]="listItem.item"
            (editName)="onEditCustomObjectName(listItem.item)"
            (retrain)="onRetrainCustomObject(listItem.item)"
            (remove)="onDeleteCustomObject(listItem.item)">
          </ui-custom-object-state-card>
        }
      </div>
    }
  }
</div>
</ng-container>
<ng-template #disabledFeature>
  <div class="h-100 w-100 flex-col center-center">
    Custom objects feature is disabled.
  </div>
</ng-template>